import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isHomePath } from "../utils/homePath";

const Navigation = ({ onLinkClick }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const langPrefix = location.pathname.startsWith("/en") ? "/en" : "";
  const sectionItems = [
    { name: t("nav.home"), sectionId: "home" },
    { name: t("nav.about"), sectionId: "animated-text" },
    { name: t("nav.offer"), sectionId: "plans" },
    { name: t("nav.projects"), sectionId: "portfolio" },
    { name: t("nav.contact"), sectionId: "form" },
  ];

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    // Push hash into history so browser Back returns here instead of leaving site
    try {
      window.history.pushState({ sectionId }, "", `#${sectionId}`);
    } catch (_) {}
    const element = sectionId === 'home' ? document.querySelector('.home') : document.querySelector(`[data-section="${sectionId}"]`);
    if (element) {
      try { window.dispatchEvent(new CustomEvent('overlay:show', { detail: { duration: 900 } })); } catch(_) {}
      const rect = element.getBoundingClientRect();
      const pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      let offset = 0;
      if (sectionId === 'portfolio') {
        offset = 480; // apply -100px only for portfolio
      }
      if (sectionId === 'form') {
        offset = -50; // apply -100px only for portfolio
      }
      if(sectionId === 'animated-text') {
        offset = -350; // scroll further down for "Kim jesteśmy" section
      }
      
      const top = rect.top + pageTop - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    // Call the callback to close mobile menu if provided
    if (onLinkClick) {
      onLinkClick();
    }
  };

  const isHomeRoute = isHomePath(location.pathname);

  if (isHomeRoute) {
    return (
      <nav className="navigation">
        <ul>
          {sectionItems.map((item, index) => (
            <li key={index}>
              <Link 
                to="#"
                onClick={(e) => handleSectionClick(e, item.sectionId)}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    );
  }

  return (
    <nav className="navigation">
      <ul>
        {sectionItems.map((item, index) => (
          <li key={index}>
            <Link
              to={
                item.sectionId === "home"
                  ? `${langPrefix}/`
                  : `${langPrefix}/#${item.sectionId}`
              }
              onClick={onLinkClick}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
